import { Property } from "@/interfaces/property.interface";
import { useTranslations } from "use-intl";

interface PropertyLastUpdatedBadgeProps {
  property: Property;
}
export const PropertyLastUpdatedBadge = ({
  property,
}: PropertyLastUpdatedBadgeProps) => {
  const t = useTranslations("shared");

  if (!property.lastUpdated) {
    return <></>;
  }

  return (
    <div className=" bg-white shadow-md  bottom-4 left-3 absolute text-xs px-2 rounded-md py-0.5 flex items-center gap-x-2 line-clamp-1">
      <div className=" w-2 h-2 bg-teal-500 rounded-full -mt-0.5 " />{" "}
      {t(`words.added-at`)}{" "}
      {new Date(property.lastUpdated).toLocaleDateString()}
    </div>
  );
};
